var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "399.057,290.006 402.279,301.309 413.476,268.033 382.42,284.407 394.092,285.78   356.819,329.578 356.495,328.65 386.265,267.007 392.236,277.131 394.671,242.107 368.753,265.79 380.395,264.172 350.624,325.814   349.696,326.138 360.825,269.714 369.157,278.002 362.672,243.498 343.572,272.956 354.428,268.452 342.429,329.292   338.511,337.404 334.29,340.234 332.554,349.037 317.793,366.381 329.316,365.454 327.225,376.054 331.301,373.321 331.695,378.212   338.697,369.984 345.135,379.586 349.542,357.241 355.357,350.409 354.949,345.343 358.867,337.231 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M130.919,256.928c1.266-5.692,0.481-11.024-1.687-14.309c-3.356,2.056-6.327,6.553-7.593,12.244  c-0.586,2.636-0.691,5.172-0.464,7.486l-6.97-10.391c2.838-2.314,5.281-6.277,6.39-11.261c1.266-5.692,0.481-11.024-1.687-14.309  c-3.356,2.056-6.327,6.553-7.593,12.244c-0.674,3.032-0.732,5.932-0.343,8.505l-4.712-7.024c0.236-3.568-0.859-7.907-3.489-12.041  c-3.129-4.92-7.455-8.135-11.311-8.925c-0.92,3.827,0.16,9.108,3.289,14.027c2.659,4.181,6.172,7.027,9.537,8.303l4.318,7.168  c-2.166-1.443-4.818-2.621-7.85-3.295c-5.692-1.266-11.024-0.481-14.309,1.687c2.056,3.356,6.553,6.327,12.245,7.593  c4.985,1.109,9.609,0.576,12.909-1.014l6.457,10.718c-2-1.187-4.341-2.167-6.978-2.754c-5.692-1.266-11.024-0.481-14.309,1.687  c2.056,3.356,6.553,6.327,12.245,7.593c4.772,1.061,9.214,0.617,12.485-0.811l5.946,9.869c-1.838-0.992-3.884-1.843-6.202-2.358  c-5.692-1.266-11.024-0.481-14.309,1.687c2.056,3.356,6.553,6.327,12.245,7.593c4.561,1.015,8.838,0.666,12.068-0.61l5.734,9.517  c-1.647-0.806-3.42-1.513-5.414-1.957c-5.692-1.266-11.024-0.481-14.309,1.687c2.056,3.356,6.553,6.327,12.245,7.593  c4.348,0.967,8.469,0.723,11.645-0.407l5.222,8.668c-1.436-0.635-2.964-1.189-4.639-1.561c-5.692-1.266-11.024-0.481-14.309,1.687  c2.056,3.356,6.553,6.327,12.245,7.593c4.147,0.922,8.081,0.732,11.194-0.265l16.588,27.533l7.046-4.482l-17.906-26.695  c2.222-2.396,4.062-5.88,4.984-10.026c1.266-5.692,0.481-11.024-1.687-14.309c-3.356,2.056-6.327,6.553-7.593,12.244  c-0.372,1.675-0.518,3.292-0.553,4.862l-5.636-8.403c2.369-2.398,4.337-6.027,5.304-10.375c1.266-5.692,0.481-11.024-1.687-14.309  c-3.356,2.056-6.327,6.553-7.593,12.244c-0.443,1.994-0.554,3.899-0.523,5.732l-6.189-9.226c2.525-2.385,4.653-6.111,5.668-10.672  c1.266-5.692,0.481-11.024-1.687-14.309c-3.356,2.056-6.327,6.553-7.593,12.244c-0.515,2.317-0.613,4.531-0.493,6.616l-6.417-9.567  C127.573,265.535,129.857,261.699,130.919,256.928z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M203.034,256l-8.828-52.966h-1.366c-8.014,0-13.672-7.851-11.138-15.453l0.028-0.085   c2.025-6.075-1.192-12.653-7.231-14.784L53.293,129.933c-6.87-2.425-13.341,4.484-10.471,11.181l13.144,30.669   c3.781,8.823,10.336,16.173,18.671,20.936l33.623,19.213c10.044,5.739,21.411,8.758,32.979,8.758h0.003l3.016,6.032   C153.229,244.665,171.569,256,191.631,256H203.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M308.966,256l8.828-52.966h1.366c8.014,0,13.672-7.851,11.138-15.453l-0.028-0.085   c-2.025-6.075,1.192-12.653,7.231-14.784l121.158-42.762c6.889-2.432,13.377,4.497,10.499,11.212l-13.123,30.621   c-3.781,8.823-10.336,16.173-18.671,20.936l-33.623,19.213c-10.044,5.739-21.411,8.758-32.979,8.758h-0.003l-3.016,6.032   C358.771,244.665,340.431,256,320.369,256H308.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M291.31,194.207l-21.897-51.093c-2.782-6.491-9.165-10.7-16.227-10.7h-6.013l-8.828,8.828h-8.828   l-8.828,8.828h12.319c3.123,0,5.229,3.193,3.999,6.064l-16.318,38.074h70.621L291.31,194.207L291.31,194.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M229.517,282.483L211.862,256l-16.168,16.168c-6.783,6.783-11.894,15.053-14.928,24.154   l-4.215,12.644l-8.828,8.828H156.25c-3.788,0-7.251,2.14-8.945,5.529l-2.49,4.979c-1.642,3.284,0.746,7.148,4.417,7.148h18.492   l5.885-11.77l28.144-14.072c0.849-0.424,1.623-0.983,2.294-1.654L229.517,282.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M282.483,282.483L300.138,256l16.168,16.168c6.783,6.783,11.894,15.053,14.928,24.154l4.215,12.644   l8.828,8.828h11.474c3.788,0,7.251,2.14,8.945,5.529l2.49,4.979c1.642,3.284-0.746,7.148-4.417,7.148h-18.492l-5.885-11.77   l-28.144-14.072c-0.849-0.424-1.623-0.983-2.294-1.654L282.483,282.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M229.517,291.31l-21.454,35.757c-2.894,4.824-1.842,11.037,2.48,14.639l32.579,27.15   c7.46,6.216,18.295,6.216,25.755,0l32.579-27.15c4.322-3.601,5.374-9.815,2.48-14.639l-21.454-35.757H229.517z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M256,185.379c0,0-26.483,8.828-61.793,0c0,0,0,17.655,0,35.31s8.828,70.621,61.793,88.276  c52.966-17.655,61.793-70.621,61.793-88.276s0-35.31,0-35.31C282.483,194.207,256,185.379,256,185.379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M256,185.379c0,0-26.483,8.828-61.793,0c0,0,0,17.655,0,35.31h123.586c0-17.655,0-35.31,0-35.31  C282.483,194.207,256,185.379,256,185.379z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M212.664,277.163V220.69h-9.63v39.294C205.536,265.732,208.68,271.551,212.664,277.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M231.925,220.69h-9.63v67.759c2.916,2.889,6.104,5.639,9.63,8.199V220.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M299.336,277.163c3.984-5.612,7.129-11.432,9.63-17.179V220.69h-9.63V277.163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M251.185,220.69h-9.63v81.932c3.016,1.626,6.23,3.105,9.63,4.449V220.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M289.705,220.69h-9.63v75.957c3.526-2.56,6.714-5.31,9.63-8.199V220.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M270.445,302.622V220.69h-9.63v86.381C264.215,305.727,267.429,304.248,270.445,302.622z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#73AF00"
    },
    points: "163.185,324.979 156.915,328.837 167.448,346.32 174.494,341.838 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "358.642,337.697 353.103,326.621 342.956,326.621 342.429,329.292 338.511,337.404    334.29,340.234 332.554,349.037 317.793,366.381 329.316,365.454 327.225,376.054 331.301,373.321 331.695,378.212    338.698,369.984 345.135,379.586 349.542,357.241 355.357,350.408 354.949,345.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "84.493,220.69 61.793,220.69 63.83,226.801 50.443,273.655 37.056,226.801 39.094,220.69    16.394,220.69 22.505,228.838 41.131,294.027 39.094,300.138 61.793,300.138 59.756,294.027 78.381,228.838  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4173CD"
    },
    points: "469.123,226.365 472.906,220.69 469.123,220.69 453.99,220.69 450.207,220.69    453.99,226.365 453.99,294.463 450.207,300.138 453.99,300.138 469.123,300.138 472.906,300.138 469.123,294.463  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVi);
export default __webpack_public_path__ + "static/media/VI.ffd609b53dfd8ed22e800e9f9a20091b.svg";
export { ForwardRef as ReactComponent };